import {
  AccountBalanceOutlined,
  AssessmentOutlined,
  AssignmentOutlined,
  AssignmentTurnedInOutlined,
  BusinessOutlined,
  ClassOutlined,
  ConstructionOutlined,
  FolderSharedOutlined,
  HelpOutlineOutlined,
  HomeOutlined,
  KeyOutlined,
  ListAltOutlined,
  MonetizationOn,
  MonetizationOnOutlined,
  PeopleOutlineOutlined,
  PersonOutline,
  QuestionMarkRounded,
  ReportOutlined,
  ShieldOutlined,
  TextSnippetOutlined,
  TitleOutlined,
} from "@mui/icons-material";
import {
  amber,
  blue,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  orange,
  purple,
  red,
  teal,
  yellow,
} from "@mui/material/colors";
import PropTypes from "prop-types";
import { useMemo } from "react";
import Flx from "../../../components/layout/Flx";

const LoanDocumentGroupIcon = ({
  docGroup,
  styled,
  background,
  borderColor,
  size = 18,
  sx,
}) => {
  const documentIconMap = useMemo(
    () => ({
      Appraisal: (
        <AssessmentOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Borrower Documents": (
        <FolderSharedOutlined className="thin" sx={{ color: "#ffffff" }} />
        // <PeopleOutlineOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Closing Package": (
        <AssignmentTurnedInOutlined
          className="thin"
          sx={{ color: "#ffffff" }}
        />
      ),
      "Construction Documents": (
        <ConstructionOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Entity Docs": (
        <BusinessOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Insurance Docs": (
        <ShieldOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      Liquidity: (
        <MonetizationOnOutlined className="thin" sx={{ color: "#ffffff" }} />
        // <AccountBalanceOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Leases & Rents": (
        <KeyOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Letter of Explanation & Exceptions": (
        <HelpOutlineOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Property Documents": (
        <HomeOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      Questionnaires: (
        <AssignmentOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      Memos: <TextSnippetOutlined className="thin" sx={{ color: "#ffffff" }} />,
      "Terms & Sizer": (
        <ListAltOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Third Party Reports": (
        <ReportOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      "Title Docs": (
        <ClassOutlined className="thin" sx={{ color: "#ffffff" }} />
      ),
      undefined: (
        <QuestionMarkRounded className="thin" sx={{ color: "#ffffff" }} />
      ),
    }),
    []
  );

  const documentColorMap = useMemo(
    () => ({
      Appraisal: indigo[500],
      "Borrower Documents": teal[500],
      "Closing Package": green[600],
      "Construction Documents": orange[500],
      "Entity Docs": blue[600],
      "Insurance Docs": amber[600],
      Liquidity: yellow[800],
      "Leases & Rents": brown[500],
      "Letter of Explanation & Exceptions": red[500],
      "Property Documents": deepOrange[400],
      Questionnaires: cyan[500],
      Memos: purple[400],
      "Terms & Sizer": lightBlue[500],
      "Third Party Reports": deepPurple[500],
      "Title Docs": amber[700],
      undefined: grey[300],
    }),
    []
  );

  const returnValue = documentIconMap[docGroup] || (
    <PersonOutline className="thin" />
  );

  if (styled) {
    const colorBackground = "transparent";
    const colorBorder = grey[200];

    return (
      <StyledBox
        color={documentColorMap[docGroup]}
        background={colorBackground}
        borderColor={colorBorder}
        size={size}
        sx={sx}
      >
        {returnValue}
      </StyledBox>
    );
  }

  return returnValue;
};

const StyledBox = ({
  children,
  color,
  background = grey[100],
  borderColor,
  size = 24,
  sx,
}) => {
  return (
    <Flx
      center
      sx={{
        border: `1px solid ${borderColor}`,
        background: background,
        width: size,
        height: size,
        borderRadius: 1,
        flexGrow: 0,
        flexShrink: 0,
        ".MuiSvgIcon-root": {
          fontSize: size - 6,
          color: color,
        },
        ...sx,
      }}
    >
      {children}
    </Flx>
  );
};

LoanDocumentGroupIcon.propTypes = {
  docGroup: PropTypes.string,
  styled: PropTypes.bool,
  background: PropTypes.string,
  borderColor: PropTypes.string,
  size: PropTypes.number,
  sx: PropTypes.object,
};

StyledBox.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  background: PropTypes.string,
  borderColor: PropTypes.string,
  size: PropTypes.number,
  sx: PropTypes.object,
};

export default LoanDocumentGroupIcon;
